import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-i-frame-principal',
  templateUrl: './i-frame-principal.component.html',
  styleUrls: ['./i-frame-principal.component.sass']
})
export class IFramePrincipalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
